<template>
  <!-- 新增的对话框 -->
  <el-dialog center width="600px" title="增加部门" :visible.sync="dialogFormVisible"
  >
    <el-form :model="addForm" :rules="addRules" ref="addForm">
      <el-form-item label="部门名称" :label-width="formLabelWidth" prop="name">
        <el-input v-model="addForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="部门编号" :label-width="formLabelWidth" prop="number">
        <el-input v-model="addForm.number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="部门简称" :label-width="formLabelWidth" prop="short_name">
        <el-input v-model="addForm.short_name"  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="部门性质" :label-width="formLabelWidth" prop="property">
        <el-input  v-model="addForm.property" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="负责人" :label-width="formLabelWidth" prop="duty_people">
        <el-input v-model="addForm.duty_people" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="电话号码" :label-width="formLabelWidth" prop="phone_num">
        <el-input v-model="addForm.phone_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分机号" :label-width="formLabelWidth" prop="exten_num">
        <el-input v-model="addForm.exten_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="addForm.remark" type="textarea" :rows="2" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitAdd">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formData, formRules} from '../form.js'
export default {
  data() {
    return {
      // 是否显示 对话框
      dialogFormVisible: false,
      addForm: {...formData},
      addRules: formRules,
      formLabelWidth: "120px"
    };
  },
  methods: {
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
           window.console.log(valid)
        } else {
          this.$message.warning("格式不太对哦，检查一下");
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
